import Query from "@arcgis/core/rest/support/Query";
import { Option } from "../components/shared/selectInput/types/selectInputProps";
import { makeQuery } from "../services/arcGisService/arcGisService";
import { notifyError } from "../components/snackbar/snackbar";
import esriRequest from "@arcgis/core/request.js";

export type Dictionary = {
    [key: string]: Option[];
}

export const getAdditionalDictionaries = (baseUrl: string, Definitions: string[][], Dictionary: Dictionary, synch?: boolean, miejscowosciGminyWhere?: string, isLocal?: boolean) => {
    if (!isLocal && !miejscowosciGminyWhere) {
        Definitions = Definitions.filter(item => item[1] !== "MIEJSCOWOSCI")
    }
    
    return new Promise((resolve, reject) => {
        esriRequest(baseUrl + "query", {
            query: {
                f: "json",
                outFields: ["*"],
                where: `1=1`,
                returnGeometry: "false",
                layerDefs: getLayerDefs(Definitions, synch, miejscowosciGminyWhere)
            }
        }).then((response) => {
            var features: any[] = [];
            if(response.data.layers !== undefined) features = features.concat(response.data.layers);
            features.forEach(layer => {
                var definition = Definitions.find(def => def[0] === layer.id.toString());
                if (definition) {
                    Dictionary[definition[1]] = layer.features.map((feature: any) => {
                        return (
                            {
                                value: feature.attributes[definition![2]],
                                name: feature.attributes[definition![3]],
                                anothers: feature.attributes
                            }
                        );
                    })
                    resolve(Dictionary);
                }
            })
        }).catch(() => {
            var Dictionary: Dictionary = {}
            reject(Dictionary);
            notifyError({ message: "Błąd pobierania słownika" })
        });
    })
}

const getLayerDefs = (dictDefinitions: string[][], synch?: boolean, miejscowosciGminyWhere?: string) => {
    var layerDefsInner: string[] = [];
    dictDefinitions.forEach(dict => {
        var where = "1=1";
        var outfields = "*";
        if (dict[1] === "MIEJSCOWOSCI") {
            outfields = '["NAZWA", "ID", "GMI_ID", "GLOBALID"]';
            if(synch) where += " AND SYM=SYMPODST";
            else if (miejscowosciGminyWhere) where += ` AND SYM=SYMPODST AND ${miejscowosciGminyWhere}`;
        }
        var def = `{ "layerId" : ${dict[0]}, "where": "${where}", "outfields": ${outfields.length > 1 ? outfields : `"${outfields}"`} }`;
        layerDefsInner.push(def);
    })
    return `[${layerDefsInner.join(',')}]`;
}

export const getDictionariesForValidation = (baseUrl: string, Definitions: string[][], Dictionary: Dictionary, miejscowosciGminyWhere?: string) => {
    return getAdditionalDictionaries(baseUrl, Definitions, Dictionary, false, miejscowosciGminyWhere);

    // var defs = ["INFRASTRUKTURA_KOMUNIKACYJNA", "KATEGORIA_DROGI"];
    // if (miejscowosciGminyWhere !== undefined) defs.push("MIEJSCOWOSCI");
    // var filteredDefinitions = Definitions;

    // if (filteredDefinitions === undefined) {
    //     return Promise.all([]);
    // } else {
    //     return Promise.all(filteredDefinitions.map((Definition) => {
    //         var query = new Query({
    //             outFields: ["*"],
    //             where: `1=1`
    //         });

    //         if (Definition && Definition[1] === "MIEJSCOWOSCI") {
    //             query.where += ` AND SYM=SYMPODST AND ${miejscowosciGminyWhere}`;
    //             query.outFields = ["NAZWA", "ID", "GMI_ID", "GLOBALID"];
    //             query.returnDistinctValues = true;
    //             query.returnGeometry = false;
    //         }

    //         return new Promise((resolve, reject) => {
    //             makeQuery({ url: baseUrl + Definition[0] }, query).then((featureSet: __esri.FeatureSet) => {
    //                 Dictionary[Definition[1]] = featureSet.features.map((feature) => {
    //                     return (
    //                         {
    //                             value: feature.attributes[Definition[2]],
    //                             name: feature.attributes[Definition[3]],
    //                             anothers: feature.attributes
    //                         })
    //                 });
    //                 resolve(Dictionary);
    //             }).catch((err: any) => {
    //                 if (err?.reason !== "cancel") {
    //                     var Dictionary: Dictionary = {}
    //                     reject(Dictionary);
    //                     notifyError({ message: "Błąd pobierania słownika" })
    //                 }
    //             })
    //         })
    //     }));
    // }
}

export const getDictionariesFromLayers = (layers: __esri.FeatureLayer[], layerIds: number[]) => {
    var fields: __esri.Field[] = [];
    layers.filter((layer) => {
        return layerIds.includes(+layer.id);
    }).map((layer) => {
        var fields = layer.fields.filter((field) => {
            return field.domain != null;
        })
        return fields;
    }).forEach((Fields) => {
        fields = fields.concat(Fields);
    });
    var dictionary: Dictionary = {};
    fields.forEach((field) => {
        var codedValues = (field.domain as any).codedValues;
        dictionary[field.name] = getCodedValues(codedValues as __esri.CodedValue[]);
    })
    return dictionary;
}

export const getDictionaryForCodedValues = async (url: string) => {
    const urlSearchParams = new URLSearchParams({
        f: "json",
    });
    const response = await esriRequest(url, {
        query: urlSearchParams,
        responseType: "json"
    });
    var features: __esri.FeatureLayer[] = [];
    if(response.data !== undefined) features = features.concat(response.data as __esri.FeatureLayer[]);
    return features;
}

const getCodedValues = (codedValues: __esri.CodedValue[]) => {
    return codedValues.map((value) => {
        return {
            name: value.name,
            value: value.code
        }
    });
}

export const getDictionaryForEditing = (dictUrl: string) => {
    var query = new Query({
        outFields: ["*"],
        where: `1=1`
    });
    return (
        new Promise((resolve, reject) => {
            makeQuery({ url: dictUrl }, query).then((featureSet: __esri.FeatureSet) => {
                var dict = featureSet.features.map((feature) => feature.attributes);
                resolve(dict);
            }).catch((err: any) => {
                if (err?.reason !== "cancel") {
                    reject([]);
                    notifyError({ message: "Próba pobrania słownika do edycji zakończona niepowodzeniem" })
                }
            })
        })
    );
}